import request from '../request';
import { url } from '../service-utils';

/**
 * 查询初始状态
 */
export async function getPrivateSettings() {
  return request(`${url.salaryApi}/salary/privacy/privacyViewStatus`);
}

/**
 * 开启密码验证
 * @param {Object} params
 * @param {String} params.password
 */
export async function openVerification(params) {
  return request(`${url.salaryApi}/salary/privacy/openPwd`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 修改密码
 * @param {Object} params
 * @param {String} params.newPassword
 * @param {String} params.oldPassword
 */
export async function updatePassword(params) {
  return request(`${url.salaryApi}/salary/privacy/updatePwd`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 修改密码
 * @param {Object} params
 * @param {String} params.password
 */
export async function closeVerification(params) {
  return request(`${url.salaryApi}/salary/privacy/closePwd`, {
    method: 'POST',
    data: params,
  });
}
